import { useEffect, useRef, useState, type FC, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import React from 'react';

import { cx } from '../../../utils/cx';
import styles from './Tooltip.module.scss';

interface TooltipProps {
    text?: string;
    align?: 'left' | 'right';
    children: ReactNode;
    className?: string;
}

export const Tooltip: FC<TooltipProps> = ({ text, align = 'left', children, className }) => {
    const hostRef = useRef<HTMLSpanElement>(null);
    const [at, setAt] = useState<{ x: number; y: number } | null>(null);

    /* Подпись могли скрыть снаружи, обнулив text: тогда убираем уже показанную. */
    useEffect(() => {
        if (!text) setAt(null);
    }, [text]);

    const show = () => {
        const control = hostRef.current?.firstElementChild as HTMLElement | null;
        if (!control || !text) return;

        const box = control.getBoundingClientRect();
        setAt({
            x: align === 'right' ? box.right : box.left,
            y: box.bottom + 6,
        });
    };

    const hide = () => setAt(null);

    return (
        <>
            <span ref={hostRef} className={styles.host} onMouseEnter={show} onMouseLeave={hide}>
                {children}
            </span>

            {at &&
                createPortal(
                    <span
                        className={cx(styles.tip, align === 'right' && styles.tipRight, className)}
                        style={
                            align === 'right'
                                ? { right: window.innerWidth - at.x, top: at.y }
                                : { left: at.x, top: at.y }
                        }
                    >
                        {text}
                    </span>,
                    document.body,
                )}
        </>
    );
};
